module.exports = __webpack_public_path__ + "img/ic-industry.a35ec91.svg";